'use client';

import { Popover, PopoverContent, PopoverTrigger } from '@nextui-org/react';
import { useState } from 'react';

import { CaretDown } from '@phosphor-icons/react';
import Image from 'next/image';
import Link from 'next/link';

const MenuContact = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover placement='bottom-end' isOpen={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger>
        <div className='flex items-center gap-2 cursor-pointer'>
          <p className='font-semibold md:font-medium text-base text-gray-500 hover:opacity-50'>
            Contact
          </p>
          <CaretDown size={20} />
        </div>
      </PopoverTrigger>
      <PopoverContent className='min-w-[180px] bg-white p-2 rounded-2xl border border-[#19052f0d] shadow-sm'>
        <Link
          href='https://zaloapp.com/qr/p/nk2hky1xg9up'
          target='_blank'
          className='w-full text-primary font-medium cursor-pointer flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-[#cccccc1f]'
        >
          <Image src='/assets/svg/zalo.svg' alt='Zalo' width={20} height={20} />
          <span className=''>Zalo</span>
        </Link>
        <Link
          href='https://t.me/Mayyy_Le'
          target='_blank'
          className='w-full text-primary font-medium cursor-pointer flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-[#cccccc1f]'
        >
          <Image src='/assets/svg/telegram.svg' alt='Telegram' width={20} height={20} />
          <span className=''>Telegram</span>
        </Link>
      </PopoverContent>
    </Popover>
  );
};

export default MenuContact;
